export const en = {
    'different-protocols': 'Mixed',
    'site-link-descr': 'Description',
    'site-link-different-values-placeholder': 'The selected ads have different values',
    'site-link-link': 'Link to site',
    'site-link-placeholder': 'Fill in the field',
    'site-link-title': 'Title',
    'site-link-turbo-error': 'Turbo page is not specified or specified incorrectly'
};
